export default __webpack_public_path__ + "static/asesor-two-6fbe8fae900b25594fada57d88274531.png";